export default "__VITE_ASSET__BRFeXsLp__"